import { UsageCostAugmentedEntry, UsageCostLabelsMap } from '../hooks'
import { flattenUsageCostAugmentedEntry } from './flattenUsageCost'

const USAGE_VARIANCE_KEY = 'usage_commodityUsage'
const USAGE_BASELINE_KEY = 'usage_baselineUsage'

const COST_VARIANCE_KEY = 'cost_commodity_totalCommodityCost'
const COST_BASELINE_KEY = 'cost_baselineCost'

export const doesDataHasVariance = (data: UsageCostAugmentedEntry[]) => {
    const flattenedData = data.map(flattenUsageCostAugmentedEntry)

    const hasUsageVariance = [USAGE_VARIANCE_KEY, USAGE_BASELINE_KEY].every(
        (key) =>
            flattenedData.some(
                (item) =>
                    key in item && item[key as keyof typeof item] !== undefined
            )
    )

    const hasCostVariance = [COST_VARIANCE_KEY, COST_BASELINE_KEY].every(
        (key) =>
            flattenedData.some(
                (item) =>
                    key in item && item[key as keyof typeof item] !== undefined
            )
    )

    return hasUsageVariance || hasCostVariance
}

export const getVarianceDataSetPreviousLabel = ({
    dataKey,
    labelsMap,
}: {
    dataKey: string
    labelsMap: UsageCostLabelsMap
}) => {
    if (dataKey === labelsMap[USAGE_VARIANCE_KEY]) {
        const label = labelsMap[USAGE_BASELINE_KEY]
        return label
    }

    if (dataKey === labelsMap[COST_VARIANCE_KEY]) {
        const label = labelsMap[COST_BASELINE_KEY]
        return label
    }
    return undefined
}
